
import { Voni } from '../client';

export interface Message {
  id: number;
  conversation_id: number;
  role: string;
  content: string;
  created_at: string;
  updated_at: string;
}

export interface MessageCreateInput {
  conversation_id: number;
  role: string;
  content: string;
}

export interface MessageUpdateInput {
  role?: string;
  content?: string;
}

export class MessageResource {
  constructor(private client: Voni) {}

  async list(conversationId: number): Promise<Message[]> {
    return this.client.request<Message[]>('GET', '/messages/', { conversation_id: conversationId });
  }

  async get(messageId: number): Promise<Message> {
    return this.client.request<Message>('GET', `/messages/${messageId}`);
  }

  async create(data: MessageCreateInput): Promise<Message> {
    return this.client.request<Message>('POST', '/messages/', undefined, data);
  }

  async update(messageId: number, data: MessageUpdateInput): Promise<Message> {
    return this.client.request<Message>('PUT', `/messages/${messageId}`, undefined, data);
  }

  async delete(messageId: number): Promise<boolean> {
    await this.client.request('DELETE', `/messages/${messageId}`);
    return true;
  }
}
